import React, { useState } from 'react';
import Modal from 'react-modal';
import LoadingSpinner from '../../common/LoadingSpinner';


type TModalConfirmCancelShiftProps = {
    handleClose: (modalName: string) => void;
    isOpen: boolean;
    updateJobStatus: (jobId: number, status: string, data?: object) => void;
    jobId: number;
}

export function ModalConfirmCancelShift({
    handleClose,
    isOpen,
    updateJobStatus,
    jobId,
}: TModalConfirmCancelShiftProps) {

    const [isLoading, setIsLoading] = useState(false);
    const [isSilent, setIsSilent] = useState(false);

    const handleConfirm = (): void => {
        setIsLoading(true);
        updateJobStatus(jobId, 'cancel', { is_silent: isSilent });
        setIsLoading(false);
        handleClose('ConfirmCancelShift');
    };

    return (
        <Modal
            className="cancel-worker-modal"
            isOpen={isOpen}
            onRequestClose={() => handleClose('ConfirmCancelShift')}
            contentLabel="Cancel shift"
            ariaHideApp={false}
        >
            <p className="modal-title">Cancel shift</p>
            <div className="cancel-worker-body">
                <p>Are you sure you want to cancel the shift <b>{jobId}</b> ?</p>

                <div className="margin-top-20">
                    <label className="cancel-worker-checkbox">
                        <input
                            className="checkbox-purple"
                            type="checkbox"
                            checked={isSilent}
                            onChange={event => {
                                setIsSilent(event.target.checked);
                            }}
                        />
                        <span>Cancel silently</span>
                    </label>
                </div>
            </div>

            <button
                className="continue btn--round-big"
                onClick={handleConfirm}
                type="button"
                disabled={isLoading}
            >
                {isLoading ? (
                    <LoadingSpinner
                        className="cancel-worker-spinner"
                        backgroundColor="white"
                    />
                ) : (
                    'CONFIRM'
                )}
            </button>
            {!isLoading && (
                <button className="back" onClick={() => handleClose('ConfirmCancelShift')} type="button">
                    CANCEL
                </button>
            )}
        </Modal>
    );
}
